import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackOfficeService {

  constructor(private http: HttpClient) { }

  submitBackOfficeData(formData: any): Observable<any> {
    return this.http.post('/backOfficeData', formData);
  }
}
